import React, { useContext, useEffect, useState } from "react";
import c1icon from "../../../images/c1.png";
import c2icon from "../../../images/c2.png";
import c4icon from "../../../images/c4.png";
import { useNavigate } from "react-router-dom";
import { getStorage, setStorage } from "../../../Utils/common";
import ContextDashboard from "../../../Context/ContextDashboard";
import { DashboardWrapper } from "../style";
import ProgressBar from "../../../components/ProgressBar/ProgressBar";
import DashboardCard2 from "../DashboardCard2";
import { getDashboardData } from "../../../Utils/api";
import { Helmet } from "react-helmet";


const cardList = [
  {
        heading: "Loan Calculator",
        desc: "Choose the loan amount and tenure.",
        img: c1icon,
        link: "/my-dashboard/calculate-loan",
      },
      {
        heading: "Employment Information",
        desc: "Share about your work status.",
        img: c2icon,
        link: "/my-dashboard/about-your-company",
      },
      {
        heading: "Upload Your Documents",
        desc: "Share your documents to verify your details",
        img: c4icon,
        link: "/my-dashboard/adhar-upload",
      },
      {
        heading: "Banking Details",
        desc: "Share your banking details",
        img: c2icon,
        link: "/my-dashboard/bank-detail",
      },
      
    ];



function Eligibility() {
  const [cards, setCards] = useState(cardList);
  const [stepComplate, setStepComplate] = useState(false);
  const [showSteps, setShowSteps] = useState(0);
  const [toggle, setToggle] = useState(true);
  const [progressBar,setProgressBar] = useState(0)
  const {setps} = useContext(ContextDashboard);

  const navigate = useNavigate();
  const {currentEvent} = useContext(ContextDashboard);

  const redirect = (data) =>{
    console.log(data);
    navigate(data.link)
  }

 
  const utm_source = getStorage('utm_source');


useEffect(() => {
  const params = {
    profile_id: getStorage("cust_profile_id") || "",
  };

  getDashboardData(params).then(resp => {

    if (resp?.data?.Status === 1) {
      
      const dashboardData = resp?.data || {};
      setStorage('dashboardData', dashboardData);
      setStorage('percent',dashboardData?.Data?.application_filled_percent)
      setProgressBar(dashboardData?.Data?.application_filled_percent);
      setStorage('next_step',dashboardData?.Data?.next_event_name);
      setShowSteps(currentEvent(dashboardData?.Data?.next_event_name)-9);
      setStorage('utm_source',dashboardData?.Data?.profile_details?.utm_source);
    }
  });
}, []);

useEffect(()=>{
  const steps=currentEvent(getStorage("next_step"));
  setShowSteps(steps);
  
},[]);

useEffect(() => {
  // Trigger Whistle Pixel of valueleaf only if utm_source === 'VALUE_LEAF'
  const sendWhistlePixel = () => {
    const clickId = getStorage('clickId');
    const img = new Image();
    img.src = `https://utils.follow.whistle.mobi/pixel.php?click_id=${clickId}&revenue={revenue}&goal_name=Banking_Details`;
  };

  if (utm_source === 'VALUE_LEAF') {
    sendWhistlePixel();

    // Fire Google Ads conversion event if gtag is available
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', 'conversion', {
        send_to: 'AW-17083147117/Go8JCNqP7scaEO3G8NE_',
      });
    } else {
      console.warn('gtag is not defined');
    }
  }
}, [utm_source]);

  return (
   
    <>
     <Helmet>

      {/* organic pixel */}
     <script>
        {`
!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '1413461893157465');
fbq('track', 'PageView');

    `}
      </script>


<noscript>
  {`<img height="1" width="1" style="display:none"
src="https://www.facebook.com/tr?id=1413461893157465&ev=PageView&noscript=1"/>
`}
</noscript>

<script>
  {`
  fbq('track', 'CompleteRegistration', {
    value: 1,
    currency: 'inr',
  });
  `}
</script>

{/* end organic pixel */}
</Helmet>
    
    <DashboardWrapper>
      <ProgressBar value={`${progressBar}%`} title="Loan Application"  >
      </ProgressBar>

     {<div className="carde">
        {cards.map((value, index) => {
          return (
           <DashboardCard2
                number={index + 1}  // Adding the card number
                heading={value.heading}
                desc={value.desc}
                img={value.img}
                complate={(index + 1) <= showSteps}
                disable={index !== showSteps}
                key={index}
                onClick={() => redirect(value)}
              />
          );
        })}
       <div className="hideMD"></div>
      </div>
      
      }
      
    </DashboardWrapper>
    </>
  );
}

export default Eligibility;